import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@20.14.11_eslint@8.57.0_ioredis@5.4.1_magicast@0_ulnv6vkgsi3aehaog7dju7rikm/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/apps/admin/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}